import { render } from "./AdvertCard.vue?vue&type=template&id=4ceb3497&scoped=true"
import script from "./AdvertCard.vue?vue&type=script&lang=js"
export * from "./AdvertCard.vue?vue&type=script&lang=js"

import "./AdvertCard.vue?vue&type=style&index=0&id=4ceb3497&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ceb3497"]])

export default __exports__